import React, { useState } from "react";
import dispositivoAsignadoService from "../../services/dispositivo/dispositivoAsignadoService";

export const useReporteHistoricoDispositivo = (onDismiss) => {
  const [isSend, setIsSend] = useState(false);

  const handlerPostReporteDispositivoHistorico = (filterReporteHistorico) => {
    setIsSend(true);
    dispositivoAsignadoService
      .postReporteDispositivoHistorico(filterReporteHistorico)
      .then((res) => {
        if (res.status === 200) {
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "ReporteHistoricoDispositivo.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          setIsSend(false);
          onDismiss();
        }
      })
      .catch((e: Error) => {
        console.log(e.message);
        setIsSend(false);
        onDismiss();
      });
  };

  return {
    isSend,
    handlerPostReporteDispositivoHistorico,
  };
};
